export default "__VITE_ASSET__GEWkDsdr__"